import React from "react";
import {BrowserRouter as Router} from "react-router-dom";
import MainRoutes from "./MainRoutes";
import './index.css';
import SideActionsHandler from "components/side-actions-handler";

//https://www.figma.com/file/1VN02mnGyzpSBsmcnVE7Ai/%D0%A1%D1%82%D0%B5%D0%BF%D0%B5%D0%BD%D1%8C-%D0%B4%D0%B2%D0%BE%D0%B9%D0%BA%D0%B8?node-id=0%3A1
function App() {
    return (
        <Router basename={"/"}>
            <MainRoutes/>
            <SideActionsHandler/>
        </Router>
    );
}

export default App
